import { render, staticRenderFns } from "./SupportDetail.vue?vue&type=template&id=da10eac8&scoped=true&"
import script from "./SupportDetail.vue?vue&type=script&lang=js&"
export * from "./SupportDetail.vue?vue&type=script&lang=js&"
import style0 from "./SupportDetail.vue?vue&type=style&index=0&id=da10eac8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da10eac8",
  null
  
)

export default component.exports